export interface AdminRes {
  id: number;
  name: string;
  created_at: Date;
  updated_at: Date;
  is_deleted: boolean;
  admin_type: string;
  account_id: number;
  account: Account;
}

export interface Account {
  id: number;
  email: string;
  is_active: boolean;
  status: string;
  created_at: Date;
  updated_at: Date;
  is_deleted: boolean;
  account_type: string;
  approved_by_id: null;
  profile_photo_id: null;
}

export enum admin_type {
  ACADEMIC_SUPERVISOR = 'ACADEMIC_SUPERVISOR',
  PROGRAM_HEAD = 'PROGRAM_HEAD',
  SYSTEM_ADMIN = 'SYSTEM_ADMIN',
  ADMIN = 'ADMIN',
  SUPER_ADMIN = 'SUPER_ADMIN',
}
